"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
var _components = require("../../components");
require("./PromoCode.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var maybePluralize = function maybePluralize(count, noun) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';
  return "".concat(count, " ").concat(noun).concat(count !== 1 ? suffix : '');
};
var PromoCode = function PromoCode(props, _ref) {
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? 'Enter your referral code' : _props$placeholder,
    _props$size = props.size,
    size = _props$size === void 0 ? 'large' : _props$size,
    _props$onPromoApply = props.onPromoApply,
    onPromoApply = _props$onPromoApply === void 0 ? _lodash.noop : _props$onPromoApply,
    _props$onPromoApplied = props.onPromoApplied,
    onPromoApplied = _props$onPromoApplied === void 0 ? _lodash.noop : _props$onPromoApplied,
    _props$onPromoChanged = props.onPromoChanged,
    onPromoChanged = _props$onPromoChanged === void 0 ? _lodash.noop : _props$onPromoChanged,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? _lodash.noop : _props$onChange,
    value = props.value,
    initialValue = props.initialValue,
    originalPrice = props.originalPrice,
    promoPrice = props.promoPrice,
    applyingCoupon = props.applyingCoupon,
    isPriceDiscounted = props.isPriceDiscounted,
    months = props.months,
    expanded = props.expanded,
    multiline = props.multiline;
  var initialVal = initialValue || value;
  var isInitialValue = !!initialVal;
  var _useState = (0, _react.useState)((0, _lodash.toUpper)(initialVal)),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    couponErrorMessage = _useState4[0],
    setCouponErrorMessage = _useState4[1];
  var _useState5 = (0, _react.useState)(isInitialValue),
    _useState6 = _slicedToArray(_useState5, 2),
    autoApplyCode = _useState6[0],
    setAutoApplyCode = _useState6[1];
  var _useState7 = (0, _react.useState)(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    isPromoCodeValid = _useState8[0],
    setIsPromoCodeValid = _useState8[1];
  var _useState9 = (0, _react.useState)(expanded || isInitialValue),
    _useState10 = _slicedToArray(_useState9, 2),
    isExpanded = _useState10[0],
    setExpanded = _useState10[1];
  var _useUpdate = (0, _utils.useUpdate)({
      update: onPromoApply,
      handleSuccess: function handleSuccess(res) {
        setIsPromoCodeValid(true);
        setCouponErrorMessage(undefined);
        onPromoApplied(res === null || res === void 0 ? void 0 : res.data, inputValue);
      },
      handleErrors: function handleErrors(error) {
        var _error$response, _error$response$data;
        if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.code) === 'ERR400_118') {
          setCouponErrorMessage('This offer has expired');
        }
        onPromoApplied(null);
        setIsPromoCodeValid(false);
      }
    }),
    validatingPromoCode = _useUpdate.processing,
    handleValidatePromoCode = _useUpdate.handleSubmit;
  var processingPromoCode = validatingPromoCode || applyingCoupon;
  (0, _react.useEffect)(function () {
    return setInputValue((0, _lodash.toUpper)(value));
  }, [value]);
  var applyPromoCode = function applyPromoCode() {
    if (inputValue) {
      handleValidatePromoCode({
        promocode: inputValue.toUpperCase()
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (autoApplyCode && isExpanded) {
      onChange(inputValue);
      onPromoChanged();
      applyPromoCode();
    }
  }, [isExpanded]);
  (0, _react.useEffect)(function () {
    if (autoApplyCode) {
      setExpanded(true);
    }
  }, [autoApplyCode]);
  var _QueryUtils$useQuery = _utils.QueryUtils.useQuery(),
    query = _QueryUtils$useQuery.query;
  (0, _react.useEffect)(function () {
    var urlCode = query.promo;
    if (urlCode) {
      setInputValue((0, _lodash.toUpper)(urlCode));
      setAutoApplyCode(true);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (inputValue === undefined) {
      onPromoApplied(null);
    }
  }, [inputValue]);
  var handleChange = function handleChange(e) {
    var uppercasedValue = (0, _lodash.toUpper)(e.target.value);
    setInputValue(uppercasedValue);
    setCouponErrorMessage(undefined);
    setIsPromoCodeValid(null);
    onChange(uppercasedValue);
    onPromoChanged();
  };
  var isPromocodeApplicable = !!originalPrice && isPromoCodeValid;
  var isPriceWithDiscount = (0, _lodash.isUndefined)(isPriceDiscounted) ? promoPrice < originalPrice : isPriceDiscounted;
  var isPromocodeApplied = onPromoApply === _lodash.noop ? isPromocodeApplicable : isPromocodeApplicable && isPriceWithDiscount;
  var notificationText;
  var promoMonthCount;
  if (couponErrorMessage) {
    notificationText = couponErrorMessage;
    promoMonthCount = null;
  } else if (isPromoCodeValid === false) {
    notificationText = 'Referral code is not valid.';
    promoMonthCount = null;
  } else if (isPromocodeApplied) {
    var showMonths = months > 0;
    notificationText = 'Code successfully applied';
    promoMonthCount = showMonths ? /*#__PURE__*/_react.default.createElement("span", null, ", discount valid for ", maybePluralize(months, 'month'), ".") : null;
  } else {
    notificationText = 'Code provided is not applicable for this product.';
    promoMonthCount = null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "promocode"
  }, multiline ? /*#__PURE__*/_react.default.createElement("div", {
    className: "promocode-multiline"
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    ref: function ref(el) {
      return _ref = el;
    },
    placeholder: placeholder,
    size: size,
    value: inputValue,
    onChange: handleChange,
    className: "promo-input"
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "default",
    loading: processingPromoCode,
    disabled: isPromoCodeValid,
    onClick: applyPromoCode,
    className: "promo-button-multiline"
  }, "Apply referral code")) : isExpanded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "promo-apply"
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    ref: function ref(el) {
      return _ref = el;
    },
    placeholder: placeholder,
    size: size,
    value: inputValue,
    onChange: handleChange,
    className: "text-black"
  }), isPromoCodeValid ? /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    className: "absolute right-0 bottom-0 top-0",
    icon: "close-24",
    size: "large",
    onClick: function onClick() {
      setInputValue(undefined);
    }
  }) : /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "default",
    loading: processingPromoCode,
    disabled: isPromoCodeValid,
    onClick: applyPromoCode,
    className: "promo-button"
  }, "Apply"))) : /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    onClick: function onClick() {
      setExpanded(true);
    },
    icon: "add-heavy-16",
    iconSize: 16,
    size: "large",
    className: "text-green1-55"
  }, "Add a referral code"), !(0, _lodash.isNil)(isPromoCodeValid) && !(0, _lodash.isNil)(inputValue) && !processingPromoCode && /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "mt1 verification-message",
    type: "flex",
    justify: "space-between",
    align: "middle",
    gutter: 8
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "promocode-result"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('tw-body-sm-regular flex items-center', isPromocodeApplied ? 'text-green2-50' : 'text-alertred-60')
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    className: "mr-[6px]",
    type: isPromocodeApplied ? 'success-filled-24' : 'alert-filled'
  }), /*#__PURE__*/_react.default.createElement("span", null, notificationText, promoMonthCount))))));
};
var _default = /*#__PURE__*/(0, _react.forwardRef)(PromoCode);
exports.default = _default;
PromoCode.propTypes = {
  placeholder: _propTypes.default.string,
  size: _propTypes.default.oneOf(['default', 'small', 'large']),
  onPromoApply: _propTypes.default.func,
  onPromoApplied: _propTypes.default.func,
  onPromoChanged: _propTypes.default.func,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  originalPrice: _propTypes.default.number,
  promoPrice: _propTypes.default.number,
  months: _propTypes.default.number
};